import { render } from "./UserRecoverPasswordView.vue?vue&type=template&id=3f141b52&scoped=true"
import script from "./UserRecoverPasswordView.vue?vue&type=script&lang=js"
export * from "./UserRecoverPasswordView.vue?vue&type=script&lang=js"

import "./UserRecoverPasswordView.vue?vue&type=style&index=0&id=3f141b52&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f141b52"]])

export default __exports__